import { render, staticRenderFns } from "./HomeWebApp.vue?vue&type=template&id=d15bd83e&"
import script from "./HomeWebApp.vue?vue&type=script&lang=js&"
export * from "./HomeWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports